import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { fetchCustomPage } from 'client/ducks/app/actions';
import { getCustomPage, isLoading } from 'client/ducks/app/selectors';
import { State } from 'client/store';

import CustomPage, { DispatchProps, StateProps } from './custom-page';
import { AsyncFetchDataProps } from '@interfaces/async-fetch-data';

function mapStateToProps(state: State): StateProps {
    return {
        data: getCustomPage(state),
        isLoading: isLoading(state)
    };
}

const mapDispatchToProps = (dispatch: Dispatch, { match }: StateProps): DispatchProps => {
    return {
        fetchCustomPage: () => dispatch(fetchCustomPage(match.params.slug))
    };
};

const component = connect<StateProps, DispatchProps>(
    mapStateToProps,
    mapDispatchToProps
)(CustomPage) as any;

component.asyncFetchData = ({ dispatch, match }: AsyncFetchDataProps) => {
    dispatch(fetchCustomPage(match.params.slug));
};

export default component;
